import { render, staticRenderFns } from "./addZJKModal.vue?vue&type=template&id=16d66030&scoped=true"
import script from "./addZJKModal.vue?vue&type=script&lang=js"
export * from "./addZJKModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d66030",
  null
  
)

export default component.exports